import { render, staticRenderFns } from "./prepositioner-som-styr-ackusativ.vue?vue&type=template&id=40e391e7&scoped=true"
import script from "./prepositioner-som-styr-ackusativ.vue?vue&type=script&lang=js"
export * from "./prepositioner-som-styr-ackusativ.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e391e7",
  null
  
)

export default component.exports